import React from "react"

import drawing1 from "../assets/pancho-villa-bird-drawing-01.svg"
import drawing2 from "../assets/pancho-villa-lizard-drawing.svg"
import drawing3 from "../assets/pancho-villa-bird-drawing-02.svg"

export default function BackgroundDrawings(props) {

  let drawingImages = [drawing1, drawing2, drawing3];

  let drawingObjects = [];
  const numberOfDrawings = 30;

  const distanceBetweenEachDrawing = 600;

  let currentSide = false;
  let currentY = 700;
  for (let i = 0; i < numberOfDrawings; i++) {
    let drawing = {
      drawingImage: drawingImages[i % 3],
      yPosition: currentY,
      side: currentSide
    };

    drawingObjects.push(drawing);

    currentY += distanceBetweenEachDrawing;
    currentSide = !currentSide;
  }

  return (  
    <div className="background-drawings-wrapper">      
      <div className="background-drawings">  
        <div className="background-drawings-container">   
          {drawingObjects.map((drawingItem, itemIndex) => (
            <React.Fragment key={itemIndex}>
              {drawingItem.side ? 
                <div className="drawing" style={{backgroundImage: `url(${drawingItem.drawingImage})`, top: drawingItem.yPosition, left: 50}}>
                </div>
              :
                <div className="drawing" style={{backgroundImage: `url(${drawingItem.drawingImage})`, top: drawingItem.yPosition, right: 50}}>
                </div>
              }
            </React.Fragment>
          ))}
        </div>
      </div>
      {props.children}
    </div>
  )
}